module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "content-wrapper",
    staticStyle: {
      "min-height": "870px"
    }
  }, [_c('vue-headful', {
    attrs: {
      "title": 'SGP - Manuais e Modelos'
    }
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('documentos-por-tipo', {
    attrs: {
      "tipo": 45
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('documentos-por-tipo', {
    attrs: {
      "tipo": 46
    }
  })], 1)])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content-header"
  }, [_c('h1', [_c('i', {
    staticClass: "fa fa-book",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" Manuais e Modelos")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3719f1a6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/cadastro/Manuais.vue
// module id = 1905
// module chunks = 1